export default "__VITE_ASSET__DBOwcVzy__"